var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button-close',{staticClass:"button-close",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('b-icon-x')],1)}
var staticRenderFns = []

export { render, staticRenderFns }